import { useState } from 'react'
import { Link } from 'react-router-dom'
import { apiConcluirStartWizard } from '../lib/api'
import { promptInstallApp, shouldShowInstallOptin } from '../lib/pwaInstall'
import type { HubPayload } from '../types'

type Props = {
  hub: HubPayload
  onDone: (next: HubPayload) => void
  onError: (msg: string) => void
}

/**
 * Onboarding 3 passos do EleitorWEB Start.
 */
export function StartWizardCard({ hub, onDone, onError }: Props) {
  const [step, setStep] = useState(1)
  const [busy, setBusy] = useState(false)
  const [copyOk, setCopyOk] = useState(false)
  const convite = hub.convite?.convite || ''

  if (!hub.plano?.wizard_pendente) {
    return null
  }

  async function copyInvite() {
    if (!convite) return
    try {
      await navigator.clipboard.writeText(convite)
      setCopyOk(true)
      setTimeout(() => setCopyOk(false), 2000)
    } catch {
      onError('Não foi possível copiar o link.')
    }
  }

  async function finish() {
    setBusy(true)
    try {
      const next = await apiConcluirStartWizard()
      onDone(next)
    } catch (e) {
      onError(e instanceof Error ? e.message : 'Não foi possível concluir.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="bp-card" style={{ borderColor: 'var(--bp-primary)', borderWidth: 1, borderStyle: 'solid' }}>
      <p className="bp-card__eyebrow">Comece em 3 passos</p>
      <p className="bp-muted" style={{ marginTop: 0 }}>
        Plano Start · passo {step} de 3
      </p>

      {step === 1 ? (
        <>
          <p style={{ margin: '0.5rem 0' }}>Confirme seu nome e envie uma foto de perfil.</p>
          <div className="bp-stack">
            <Link className="bp-btn bp-btn--primary" to="/hub/cadastro">
              Editar nome / dados
            </Link>
            <Link className="bp-btn" to="/hub/inicio">
              Enviar foto no início
            </Link>
            <button type="button" className="bp-btn" onClick={() => setStep(2)}>
              Já fiz — próximo
            </button>
          </div>
        </>
      ) : null}

      {step === 2 ? (
        <>
          <p style={{ margin: '0.5rem 0' }}>Copie seu link de convite e envie para a rede.</p>
          {convite ? (
            <input className="bp-input" readOnly value={convite} aria-label="Link de convite" />
          ) : (
            <p className="bp-muted">Link ainda não disponível — abra Convidar no menu.</p>
          )}
          <div className="bp-stack" style={{ marginTop: '0.75rem' }}>
            <button type="button" className="bp-btn bp-btn--primary" onClick={() => void copyInvite()}>
              {copyOk ? 'Copiado!' : 'Copiar link'}
            </button>
            <Link className="bp-btn" to="/hub/convidar">
              QR / WhatsApp
            </Link>
            <button type="button" className="bp-btn" onClick={() => setStep(3)}>
              Já compartilhei — próximo
            </button>
            <button type="button" className="bp-btn" onClick={() => setStep(1)}>
              Voltar
            </button>
          </div>
        </>
      ) : null}

      {step === 3 ? (
        <>
          <p style={{ margin: '0.5rem 0' }}>Instale o app e baixe sua moldura Eu Apoio.</p>
          <div className="bp-stack">
            {shouldShowInstallOptin() ? (
              <button
                type="button"
                className="bp-btn bp-btn--primary"
                onClick={() => void promptInstallApp({ campanhaId: hub.campanha.id })}
              >
                Instalar app
              </button>
            ) : (
              <a className="bp-btn bp-btn--primary" href={`/instalar-app?c=${hub.campanha.id}`}>
                Como instalar no celular
              </a>
            )}
            <Link className="bp-btn" to="/hub/eu-apoio">
              Montar moldura
            </Link>
            <Link className="bp-btn" to="/hub/colinha">
              Abrir colinha
            </Link>
            <button type="button" className="bp-btn bp-btn--primary" disabled={busy} onClick={() => void finish()}>
              {busy ? 'Salvando…' : 'Concluir onboarding'}
            </button>
            <button type="button" className="bp-btn" onClick={() => setStep(2)}>
              Voltar
            </button>
          </div>
        </>
      ) : null}
    </section>
  )
}
